import {RestService} from "@/services/rest/RestService";
import {PopupAssociationEndpointsApi} from "@/api/pharma-cms-popup";
import {PopupAssociationOverviewResultsRestDto, PopupAssociationRestDto} from "@/api/pharma-cms-popup/models";
import {CacheService} from "@/services/cache/CacheService";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";

export class PopupAssociationRestService extends RestService {

    private apiService: PopupAssociationEndpointsApi


    protected constructor() {
        super();
        this.apiService = new PopupAssociationEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async getAssociations(popupId: string): Promise<PopupAssociationOverviewResultsRestDto> {
        const response = await this.apiService.getPopupAssociationOverview(popupId);
        return response.data;
    }

    public async addAssociation(associationRestDto: PopupAssociationRestDto, popupId: string): Promise<void> {
        await this.apiService.createPopupAssociation(associationRestDto, popupId);
    }

    public async getAssociation(associationId: string): Promise<PopupAssociationRestDto> {
        const cacheKey = CacheKeyEnum.POPUP_ASSOCIATION + '_' + associationId;
        let result: PopupAssociationRestDto | undefined = CacheService.getInstance().get(cacheKey);
        if (result) {
            return result;
        }

        const response = await this.apiService.getPopupAssociation(associationId);
        result = response.data;

        CacheService.getInstance().set(cacheKey, result);
        return result;
    }

    public async updateAssociation(associationId: string, association: PopupAssociationRestDto): Promise<void> {
        await this.apiService.updatePopupAssociation(association, associationId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_ASSOCIATION + '_' + associationId);
    }

    public async deleteAssociation(associationId: string): Promise<void> {
        await this.apiService.deletePopupAssociation(associationId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_ASSOCIATION + '_' + associationId);
    }
}
